import React from "react";
import { Col, Row, Table, Tag } from "antd";
import LabelWithInputDisabled from "../../../components/generic/LabelWithInputDisabled";

/**
 * TaskMappingView — shows the saved mapping for a Compare task in view mode.
 * Displays mapping name + full column mapping table with unique identifier flag.
 */
export default function TaskMappingView({ mappingName, mappingDetail = [] }) {
  const columns = [
    {
      title: "Source 1",
      dataIndex: "source1",
      key: "source1",
      width: "40%",
    },
    {
      title: "Source 2",
      dataIndex: "source2",
      key: "source2",
      width: "40%",
    },
    {
      title: "Unique Identifier",
      dataIndex: "rowKey",
      key: "rowKey",
      width: "20%",
      align: "center",
      render: (val) =>
        val ? (
          <Tag color="green" style={{ fontSize: 11 }}>
            Key
          </Tag>
        ) : (
          <Tag color="default" style={{ fontSize: 11, color: "#bbb" }}>
            —
          </Tag>
        ),
    },
  ];

  return (
    <>
      <Row style={{ marginBottom: 12 }}>
        <Col span={6}>
          <p className="spec-modal-label">Mapping Name</p>
        </Col>
        <Col span={18}>
          <LabelWithInputDisabled value={mappingName || "—"} />
        </Col>
      </Row>

      {mappingDetail && mappingDetail.length > 0 ? (
        <Table
          columns={columns}
          dataSource={mappingDetail.map((row, i) => ({
            ...row,
            key: row.key || i,
          }))}
          pagination={false}
          size="small"
          style={{ marginTop: 8 }}
          bordered={false}
        />
      ) : (
        <Row>
          <Col span={24}>
            <p style={{ color: "#bbb", fontSize: 13, padding: "8px 0" }}>
              No mapping configured.
            </p>
          </Col>
        </Row>
      )}
    </>
  );
}
